export const routeTypes = ['bikeOnly', 'bikeTransport', 'bikeAndRide', 'bikeSharing'];
